import type { ParentComponent } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Header } from './Header'
import { Items } from './Items'
import { useList } from './state'
import { useInfiniteScroll } from './useInfiniteScroll'

const List: ParentComponent = () => {
	const { list, pagination, setPagination, hasMore } = useService(useList)()

	let scrollRef: HTMLDivElement | undefined

	useInfiniteScroll({
		targetRef: () => scrollRef,
		onBottomReach: () => {
			if (!hasMore()) return
			const { limit, offset } = pagination()
			setPagination({ limit, offset: offset + limit })
		},
	})

	return (
		<>
			<Header />
			<main
				ref={(el) => (scrollRef = el as HTMLDivElement)}
				class={css({
					position: 'relative',
					overflowY: 'auto',
					height: 'calc(100vh - 125px)',
				})}
			>
				<Items list={list()} />
			</main>
		</>
	)
}

export default List
